import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { API_ENDPOINT, ERP_URL } from '../../index';
import {
    Row,
    Col,
    Button,
    Collapse,
    Icon,
    Tag,
    Input
} from 'antd'
import BulkyTag from '../orders-v3/tags/bulky';

import ExStockTag from '../product-ex-stock/tag'

// Same cut-off eezee-server uses (src/modules/erp/erp.config) to tell ERP carts from marketplace ones
const ERP_ORDER_ID_MIN_LENGTH = 25;

const ERP_STOP_PATHS = {
    pickup: '/inventory/pickup-order/',
    delivery: '/logistics/delivery-order/',
};

// The ERP PU / DO page of a scheduler stop, or null for marketplace stops
export const erpStopUrl = ({
    location,
}) => {
    const path = ERP_STOP_PATHS[location.locationActionRequired];
    const productOrderId = location.products && location.products[0] && location.products[0].productOrderId;
    if (!path || !productOrderId || !location.cartId || location.cartId.length < ERP_ORDER_ID_MIN_LENGTH) return null;
    return `${ERP_URL}${path}${productOrderId}`;
};

// P / D tag of a stop; ERP stops link to their PU / DO without toggling the panel
export const StopTag = ({ location, color, children }) => {
    const url = erpStopUrl({ location });
    if (!url) return <Tag color={color}>{children}</Tag>;
    return (
        <a href={url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
            <Tag color={color} style={{ cursor: 'pointer' }}>{children}</Tag>
        </a>
    );
};

class CollapsePanelContent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            editRemarksInternal: false,
            editedRemarksInternal: this.props.location.remarksInternal,
            editRemarksExternal: false,
            editedRemarksExternal: this.props.location.remarksExternal,
        }
    }

    render(){

        return(
            <Col type="flex" justify="start" style={{textAlign:'left'}}>
                <Row>
                    {this.renderRemarksInternal(this.props.location )}
                    {this.renderRemarksExternal(this.props.location )}
                </Row>
                
                <Row style={{textAlign: 'center', marginBottom:'10px'}}> 
                    {
                        this.props.location.locationActionRequired === 'pickup' ? 
                        <Tag color="magenta">Pickup</Tag> : 
                        <Tag color="green">Delivery</Tag>
                    }
                    <Tag color="cyan" >{this.props.location.address.zone}</Tag>
                    <Tag style={{marginTop:'15px'}}color='orange'>{this.props.location.deliveryOption}</Tag>
                    {
                        this.props.location.emailSent ? 
                        <Tag style={{marginTop:'15px'}}color='green'>Email Sent</Tag> :
                        <Tag style={{marginTop:'15px'}}color='#ff4d4f'>Email Not Sent</Tag>
                    }
                    <Button
                        size='small'
                        type='primary'
                        icon='file-pdf'
                        target={`/individual-do/${this.props.location._id}`}
                        href={`${API_ENDPOINT}/api/orders/do-v3/${this.props.location._id}`}
                    >
                        Download DO
                    </Button>
                </Row>

                <Row style={{borderTop:'0.5px solid #d9d9d9', paddingTop:'10px'}}> 
                    Date Purchased: <b>{this.props.location.datePurchased}</b>  
                </Row>

                {
                    this.renderDatePromised(this.props.location)
                }
                
                <Row 
                    style={{
                        borderTop:'0.5px solid #d9d9d9', 
                        paddingTop:'10px'
                    }} 
                    span={4}
                > 
                    <b>{this.props.location.address.name}</b> 
                </Row>
                
                <Row span={4} style={{marginBottom:'10px'}}> <b>{this.props.location.address.hp}</b> </Row>
                <Row span={4}> <b>{this.props.location.address.companyName}</b> </Row>
                <Row span={4}> <b>{this.props.location.address.address}</b> </Row>
                <Row span={4}> <b>{this.props.location.address.unit}</b> </Row>
                <Row span={4}> <b>{this.props.location.address.postalCode}</b> </Row>

                <Row span={4} style={{ marginTop: '10px', marginBottom: '5px', borderTop: '0.5px solid #d9d9d9' }}>Products:</Row>
                {this.props.location.products.map(_product => {

                    return <Row type="flex" justify="space-around" style={{ marginTop: '5px', borderRadius: '12px', padding: '10px' }} key={_product._id}>
                        <Col>
                            <span>{_product.positionId ? `${_product.positionId} - ` : ""}<b>{`${_product.productTitle}`}</b></span>
                            {`x${_product.quantity}`}
                            {_product.isBulky && <BulkyTag />}
                            {_product.exStock && <ExStockTag width='50px'/>}
                        </Col>
                    </Row>

                }
                
                )}
            </Col>
        )
    }
    
    renderPanelStyle = (_location) => {
        let dateScheduled = moment(_location.dateScheduled)
        let maxDeliveryDate = this.generateMaxDeliveryDate(_location)
        let style = {
            fontSize:'12px'
        }

        if(moment(dateScheduled).diff(maxDeliveryDate, 'day') > 0){
            style["border"] = '2px solid #ff7a45'
            style["borderRadius"] = '3px'
        }

        let amountOfBg = []
        let rejected = _location.products.filter(prod=>prod.rejected)
        
        if(rejected.length > 0){
            amountOfBg.push("#ffa39e")
        }
        if(_location.dateCompleted){
            amountOfBg.push("#95de64")
        }
        if(_location.plannedForRoute){
            amountOfBg.push("#69c0ff")
        }

        if(amountOfBg.length === 1){
            style["backgroundColor"] = amountOfBg[0]
        }
        if(amountOfBg.length === 2){
            style["background"] = `linear-gradient(to right, ${amountOfBg[0]} ${Math.floor(100/amountOfBg.length)}%, ${amountOfBg[1]} ${Math.floor(100/amountOfBg.length)}% )`
        }
        if(amountOfBg.length === 3){
            
            style["background"] = `linear-gradient(to right, 
                ${amountOfBg[0]} 0%,
                ${amountOfBg[0]} 33%, 
                
                ${amountOfBg[1]} 33%,
                ${amountOfBg[1]} 66%, 
                
                ${amountOfBg[2]} 66%,
                ${amountOfBg[2]} 100% )`
        }
        
        return (style)
        
    }

    renderPanelExtra = (_location) => {
        return (
            <Row type="flex" justify="space-around" align="middle">
                <Col>
                    {   
                        !this.props.zoneRules[moment(this.props.date).format('ddd')].includes(_location.address.zone) && 
                        _location.orderType != "Enterprise" && 

                        <Icon 
                            type="exclamation-circle" 
                            theme="twoTone" 
                            twoToneColor="#eb2f96" 
                            style={{marginRight:'5px'}}
                        />
                    }
                    {_location.orderType === "Enterprise" && <Icon type="bank" theme="twoTone" twoToneColor="#eb2f96" style={{marginRight:'5px'}}/>}
                </Col>
                <Col>
                {_location.locationActionRequired === "pickup" && <StopTag location={_location} color="magenta">P</StopTag>}
                { _location.locationActionRequired === "delivery" && <StopTag location={_location} color="green">D</StopTag> }
                { _location.locationActionRequired === "recieve" && <Tag color="red">R</Tag> }
                </Col>
                <Col>
                    {
                        <Button 
                            size='small' 
                            shape="circle" 
                            disabled={_location.dateCompleted} 
                            onClick={(e)=>this.props.onSelectHandler(_location , _location._id, e)} 
                            type={this.props.selectedLocations.includes(_location._id) ? "primary" : "default"}>
                                <Icon type="check" />
                        </Button>
                    }
                </Col>
            </Row>
        );
    }

    renderDatePromised = (_location) => {
        let workingDays = {
            standard: 5,
            express: 3
        }
        let numOfWorkingDays = 0
        let promisedDate = moment(_location.datePurchased, 'DD/MM/YY')
        while(numOfWorkingDays < workingDays[_location.deliveryOption]){
            let day = moment(promisedDate).add(1,'day').format('ddd')
            promisedDate = moment(promisedDate).add(1,'day')
            if(day === "Sat" || day ==="Sun"){
                continue
            }else{
                numOfWorkingDays = numOfWorkingDays + 1
            }
        }

        return(
            <Row style={{borderBottom:'0.5px solid #d9d9d9', paddingTop:'10px'}} span={4}>
                Promised Delivery Date: <b>{moment(promisedDate).format('DD/MM/YY')}</b>
            </Row>
        )
    }

    renderRemarksInternal = (_location) => {

        const { editRemarksInternal, editedRemarksInternal } = this.state

        let inputSection;

        // Edit mode 
        if (editRemarksInternal) {
            inputSection =
                <div style={{ display: 'flex', alignItems: 'center'}}> 
                    <Input.TextArea style={{marginRight: 4}} value={editedRemarksInternal} autoSize={true} onChange={(e) => {
                        this.setState({ editedRemarksInternal: e.target.value })}
                        }/>
                    <Button 
                        size='small' 
                        type='primary' 
                        icon='check' 
                        onClick={() => {

                            this.props.onUpdateRemarksInternal(`${_location._id}`,  this.state.editedRemarksInternal)
                            this.setState({ 
                                editRemarksInternal: false,
                            })
                        }}
                    />
                </div>

        } 
        // Display mode
        else {
            inputSection =
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Input.TextArea style={{ marginRight: 4 }} value={_location.remarksInternal} autoSize={true} disabled={true} />
                    <Button
                        size='small'
                        type='primary'
                        icon='edit'
                        onClick={() => this.setState({ editRemarksInternal: true })}
                    />
                </div>
        }

        
        return (
            <div>
                <div><b>Internal:</b> Notes Within Eezee</div>
                {inputSection}
            </div>
        )

    }

    renderRemarksExternal = (_location) => {

        const { editRemarksExternal, editedRemarksExternal } = this.state

        let inputSection;

        // Edit mode 
        if (editRemarksExternal) {
            inputSection = 
                <div style={{ display: 'flex', alignItems: 'center'}}> 
                    <Input.TextArea style={{marginRight: 4}} value={editedRemarksExternal} autoSize={true} onChange={(e) => {
                        this.setState({ editedRemarksExternal: e.target.value })}
                        }/>
                    <Button 
                        size='small' 
                        type='primary' 
                        icon='check' 
                        onClick={() => {

                            this.props.onUpdateRemarksExternal(`${_location._id}`,  this.state.editedRemarksExternal)
                            this.setState({ 
                                editRemarksExternal: false,
                            })
                        }}
                    />
                </div>
        } 
        // Display mode
        else {
            inputSection = 
                <div style={{ display: 'flex', alignItems: 'center'}}>
                    <Input.TextArea style={{marginRight: 4}} value={_location.remarksExternal} autoSize={true} disabled={true}/>
                    <Button 
                            size='small' 
                            type='primary' 
                            icon='edit' 
                            onClick={() => this.setState({ editRemarksExternal: true })}
                        />
                </div>
        }

        return (
            <div style={{marginTop: 4}}>
                <div><b>External:</b> Job Instructions</div>
                {inputSection}
            </div>
        )

    }

    generateMaxDeliveryDate = (_location) => {
        let workingDays = {
            standard: 5,
            express: 3
        }

        let maxDeliveryDate = moment(_location.datePurchased, 'DD/MM/YY')
        let numOfWorkingDays = 0
       
        while(numOfWorkingDays < workingDays[_location.deliveryOption]){
            let day = moment(maxDeliveryDate).add(1,'day').format('ddd')
            maxDeliveryDate = moment(maxDeliveryDate).add(1,'day')
            if(day === "Sat" || day ==="Sun"){
                continue
            }else{
                numOfWorkingDays = numOfWorkingDays + 1
            }
        }
        return(maxDeliveryDate)
    }

    shouldComponentUpdate(nextProps, nextState){

            let currentPlannedForRoute = []
            let incomingPlannedForRoute = []

            let currentRejected = []
            let incomingRejected = []

            let currentEmailSent = []
            let incomingEmailSent = []

            let currentAddress = []
            let incomingAddress = []

            let currentProducts = []
            let incomingProducts = []

            let id = this.props.location._id


            if(this.props.location.emailSent){
                currentEmailSent.push(id)
            }

            this.props.location.products.forEach(_product=>{
                currentProducts.push(_product.productOrderStatusId)
                if(_product.rejected){
                    currentRejected.push(_product.productOrderStatusId)
                }
            })

            Object.keys(this.props.location.address).map(_key=>{
                currentAddress.push( this.props.location.address[_key] )
            })

      

            let nextId = nextProps.location._id

            if(nextProps.location.emailSent){
                incomingEmailSent.push(nextId)
            }

            nextProps.location.products.forEach(_product=>{
                incomingProducts.push(_product.productOrderStatusId)
                if(_product.rejected){
                    incomingRejected.push(_product.productOrderStatusId)
                }
            })

            Object.keys(nextProps.location.address).map(_key=>{
                incomingAddress.push( nextProps.location.address[_key] )
            })
        

        if (this.props.location.remarksInternal !== nextProps.location.remarksInternal) {
            this.setState({
                editedRemarksInternal: nextProps.location.remarksInternal
            })
            return true
        }
        if (this.props.location.remarksExternal !== nextProps.location.remarksExternal) {
            this.setState({
                editedRemarksExternal: nextProps.location.remarksExternal
            })
            return true
        }

        if ((this.state.editRemarksInternal !== nextState.editRemarksInternal) ||
            (this.state.editedRemarksInternal !== nextState.editedRemarksInternal) ||
            (this.state.editRemarksExternal !== nextState.editRemarksExternal) ||
            (this.state.editedRemarksExternal !== nextState.editedRemarksExternal)
        ) {
            return true
        }

        if( currentEmailSent.sort().join() != incomingEmailSent.sort().join() ){
            return true
        }
        if( currentPlannedForRoute.sort().join() != incomingPlannedForRoute.sort().join() ){
            return true
        }
        if( currentRejected.sort().join() != incomingRejected.sort().join() ){
            return true
        }
        if( currentAddress.sort().join() != incomingAddress.sort().join() ){
            return true
        }
        if( currentProducts.sort().join() != incomingProducts.sort().join() ){
            return true
        }





        return false

    }

}
export default CollapsePanelContent;


// WEBPACK FOOTER //
// ./src/components/delivery-page/CollapsePanelContent.js